import React from 'react';
import { Divider, message, Select, Spin } from 'antd';
import s from './s.module.less';
import { ReminderSettings } from 'types/calendarSetting';
import { updateReminderSettings } from 'api/calendarSetting';

interface BookingTimeIncrementsProps {
    onUpdate: () => void;
    value?: ReminderSettings;
    /** When provided, persist against the switched provider instead of the logged-in user. */
    scheduleToken?: string;
    /** Render an outer border to match standard cards. */
    bordered?: boolean;
}

const DEFAULT_INCREMENT = 15;

const OPTIONS = [
    { label: '15 mins', value: 15 },
    { label: '20 mins', value: 20 },
    { label: '30 mins', value: 30 },
    { label: '45 mins', value: 45 },
    { label: '60 minutes', value: 60 },
    { label: 'No restriction', value: 0 },
];

const BookingTimeIncrements = (props: BookingTimeIncrementsProps) => {
    const { onUpdate, value, scheduleToken, bordered } = props;
    const [selectValue, setSelectValue] = React.useState<number>(DEFAULT_INCREMENT);
    const [loading, setLoading] = React.useState(false);

    React.useEffect(() => {
        const v = value?.bookingTimeIncrements;
        if (v === undefined || v === null) {
            setSelectValue(DEFAULT_INCREMENT);
        } else {
            setSelectValue(v);
        }
    }, [value]);

    const handleChange = async (val: number) => {
        setSelectValue(val);
        setLoading(true);
        const result = await updateReminderSettings({ bookingTimeIncrements: val }, scheduleToken);
        setLoading(false);
        if (!result.error) {
            onUpdate();
        } else {
            message.error('Could not update settings. Please try again.');
        }
    };

    return (
        <div className={`${s.wrap}${bordered ? ` ${s.bordered}` : ''}`}>
            <div className="text-gray-800 text-xl font-medium">Booking time increments</div>
            <Divider />
            <div className={s.tips}>
                Control the time intervals patients can select when booking appointments. For example, a 15-minute
                increment means patients can only book at times like 9:00, 9:15, 9:30, and 9:45 — not at odd times like
                9:07 or 9:23.
            </div>
            <Spin spinning={loading}>
                <div className={s.item}>
                    <Select
                        loading={loading}
                        value={selectValue}
                        onChange={handleChange}
                        style={{ width: '250px' }}
                        options={OPTIONS}
                    />
                </div>
            </Spin>
        </div>
    );
};

export default BookingTimeIncrements;
